// extracted by mini-css-extract-plugin
export default {"root":"NotFoundBlock_root__TsV9j","descr":"NotFoundBlock_descr__Tl9of"};